<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>结算单详情</h4>
      <el-button type="primary" @click="backTo" size="mini">返回上一级</el-button>
    </div>
    <!-- 详情 -->
    <div style="margin:10px 0 10px 10px;">
      <div>所属客户：<span>{{this.topObj.customerName}}</span></div>
      <!-- <div>车辆类型：<span>{{this.topObj.vehicleType}}</span></div> -->
      <div v-for="(item,index) in topName" :key="index">
        <div>{{item.names}}：{{item.sums}}</div>
      </div>
      <div>结算方式：<span>{{this.topObj.ccbillType}}</span></div>
      <div>结算金额：<span>{{this.topObj.totalSum}}</span></div>
    </div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>费用明细</h4>
    </div>

     <el-tabs  v-model="editableTabsValue" type="card"  style="margin-left:10px;"  @tab-click="handleClick">
    <el-tab-pane :key="index"
      v-for="(item,index) in topName"
      :label="item.names"
      :name="item.ids"
      >
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableDate"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column v-for="(item,index) in tableHeardArr" :key="index"
        :prop="item.billStandard"
        :label="item.billName">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom1.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
import {
  settlementBillDetail, // 详情
  settlementBillDetailData // 列表数据
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP003B001', '00DP003B002', '00DP003B003',
        '00DP003B004', '00DP003B005', '00DP003B006'],
      activeName: 'first',
      tableDate: [],
      tableHeardArr: [],
      editableTabsValue: '',
      title: '',
      h: '500px',
      total: 0,
      searchFrom1: {
        pageNo: 1,
        pageSize: 10
      },
      feeId: '',
      tabId: '',
      cangChuId: '',
      topObj: {},
      topName: [],
      bills: ''
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.cangChuId = localStorage.getItem('cangChuId')
    this.getDetailData()
    // this.btnFlg = getBtn(this.btnIdArr, '/waybillManagement')
  },
  methods: {
    getDetailData () {
      settlementBillDetail({
        id: this.cangChuId
      }).then(res => {
        this.topObj = res.obj
        this.topName = res.listCost
        this.editableTabsValue = this.topName[0].ids
        this.tabId = this.topName[0].ids
        this.getTableData()
        // this.bills = this.topName[0].bills
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 点击tab
    handleClick (tab, event) {
      this.feeId = tab.name
      this.tableDate = []
      this.tableHeardArr = []
      this.getTableData()
    },
    // 列表数据
    getTableData () {
      settlementBillDetailData({
        pageNo: this.searchFrom1.pageNo,
        pageSize: this.searchFrom1.pageSize,
        feeId: this.feeId || this.tabId,
        billId: this.topObj.id
      }).then(res => {
        this.tableDate = res.listData.list
        this.tableHeardArr = res.listTitle
        this.total = res.listData.total
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom1.pageSize = val
      this.getTableData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom1.pageNo = val
      this.getTableData()
    },
    // 返回
    backTo () {
      this.$router.push('/smpSettlement/CCjiesuandan')
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#0c46a2;
  color: #fff;
}

.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width:  280px;
    background-color:#fff;
}
.searchBtnBox{
  margin-top: 10px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
